import { isDefined } from "@clipboard-health/util-ts";
import { logEvent } from "@src/appV2/lib/analytics";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics/events";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export function useTrackOpportunityParameters({
  workerId,
  opportunityId,
}: {
  workerId: string;
  opportunityId: unknown;
}) {
  const history = useHistory();

  useEffect(() => {
    if (!isDefined(opportunityId)) {
      return;
    }

    const opportunityIdString = String(opportunityId);

    const searchParams = new URLSearchParams(history.location.search);
    const source = searchParams.get("utm_source");
    const medium = searchParams.get("utm_medium");

    if (!source || !medium) {
      return;
    }

    logEvent(APP_V2_APP_EVENTS.FILL_MACHINE_LINK_CLICKED, {
      workerId,
      opportunityId: opportunityIdString,
      source,
      medium,
      userType: "AGENT",
    });

    searchParams.delete("utm_source");
    searchParams.delete("utm_medium");
    history.replace({
      search: searchParams.toString(),
    });
  }, [history, workerId, opportunityId]);
}
